export default "__VITE_ASSET__9b8c9374__"